import { ESCUDERIAS, ESCUDERIAS_IMAGES, Participant, User, USER_TYPES } from '@core/data/models'

/**
 * Transform Participant DTO to User domain model.
 * Extracts escuderia, agencia, zona from tags array.
 *
 * @param participant - External Participant DTO from API
 * @returns User - Domain model for internal use
 */
export function userAdapter(participant: Participant): User {
  const { tags } = participant

  const escuderiaTag = tags.find(tag => tag.startsWith('es_'))
  const agenciaTag = tags.find(tag => tag.startsWith('cd_'))
  const zonaTag = tags.find(tag => tag.startsWith('zona_'))!

  const escuderiaRawTag = escuderiaTag ?? 'sin_escuderia'
  const escuderiaCleanTag = escuderiaTag ? escuderiaTag.replace(/^es_/, '') : 'sin_escuderia'
  const agenciaRawTag = agenciaTag ?? 'sin_agencia'

  const userType = tags.find(tag => Object.values(USER_TYPES).includes(tag as USER_TYPES))
  const defaultAvatar = 'https://secure.gravatar.com/avatar/f7219bbd71f453e41750fa3c63a11da1?size=64&default=mm'

  return {
    uid: participant.uid,
    authenticated: participant.authenticated ?? null,
    avatar: participant.avatar || defaultAvatar,
    name: participant.name,
    email: participant.email,
    cargo: participant.cargo || null,
    totalUsers: Number(participant.total) || 0,
    tags,
    userType: userType as USER_TYPES,
    points: participant.points,
    unconfirmed_email: participant.unconfirmed_email,
    celular: participant.celular || '',
    numero_de_documento: participant.numero_de_documento || '',
    update_file: participant.update_file,
    total_points: participant.total_points || 0,
    ruta: participant.ruta || '',
    escuderia: {
      name: participant.escuderia,
      tag: escuderiaRawTag,
      image: ESCUDERIAS_IMAGES[escuderiaCleanTag as ESCUDERIAS] || defaultAvatar
    },
    agencia: {
      name: participant.agencia,
      tag: agenciaRawTag
    },
    zona: {
      name: participant.zona,
      tag: zonaTag
    }
  }
}
